import {cleanFields} from '../../../utilities/helper/cleanFields';
import {jalaliToGregorian} from '../../../utilities/helper/GetPersianDateTime';
import request from '../../axios';
import {IPersonalityType} from '../getUserCooperationAgreementData/types';

const PostSignCooperationAgreement = async (
  payload: ISignCooperationAgreementPayload,
) => {
  const licenseInfo = payload.store.license_info;

  const isCorporate =
    licenseInfo.personality_type === IPersonalityType.Corporate;

  // Build the base store object
  const baseStore = {
    ...payload.store,
    license_info: {
      ...licenseInfo,
      license_issuance_date:
        jalaliToGregorian(
          licenseInfo.license_issuance_date?.replace(/-/g, '/'),
        ) ?? '',
    },
  };

  // Only add corporate fields if it's a corporate license
  if (isCorporate) {
    const corporateLicenseInfo = licenseInfo as ICorporateLicenseInfo;

    baseStore.license_info = {
      ...baseStore.license_info,
      registration_number: corporateLicenseInfo.registration_number
        ? Number(corporateLicenseInfo.registration_number)
        : undefined,
      national_company_code: corporateLicenseInfo.national_company_code
        ? Number(corporateLicenseInfo.national_company_code)
        : undefined,
    };
  }

  const transformedPayload = {
    ...payload,
    store: baseStore,
  };

  // Clean nested license_info first
  transformedPayload.store.license_info = cleanFields(
    transformedPayload.store.license_info,
  );

  // Clean store level
  transformedPayload.store = cleanFields(transformedPayload.store);

  // Clean top level
  const cleanedPayload = cleanFields(transformedPayload);

  return request.post(
    'api/v2/store/sign-cooperation-agreement',
    cleanedPayload,
  );
};

export default PostSignCooperationAgreement;
